// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f49bb802","453":"baa382a3","667":"b1ac7dd6"}[chunkId] + ".chunk.js";
};